import { render, staticRenderFns } from "./groups_editor.vue?vue&type=template&id=47f558ea&"
import script from "./groups_editor.vue?vue&type=script&lang=js&"
export * from "./groups_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f558ea')) {
      api.createRecord('47f558ea', component.options)
    } else {
      api.reload('47f558ea', component.options)
    }
    module.hot.accept("./groups_editor.vue?vue&type=template&id=47f558ea&", function () {
      api.rerender('47f558ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/groups_editor.vue"
export default component.exports